<button [ngClass]="[class,
    showSpinner ? 'sm:hover:bg-verde cursor-not-allowed' : 'sm:hover:border sm:hover:border-azul sm:hover:bg-amarilloButton_background sm:hover:text-cafe']" (click)="handleClick()"

>
  @if(showSpinner) {
    <div
      class="w-6 h-6 border-4 border-blanco border-t-transparent rounded-full animate-spin"
      role="status"
    ></div>
  } @else {
    <span>{{ label }}</span>
  }
</button>
